import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './styles/reset.styl'
import './styles/fonts.styl'
import './styles/variables.styl'

import PrismicVue from 'prismic-vue'
import linkResolver from './utils/link-resolver'
import * as Devices from 'mobile-device-detect'

import VueMeta from 'vue-meta'
import OutClickDirective from './directives/OutClickDirective'

const accessToken = 'MC5YbVRGVGhJQUFDUUFVemRh.Gu-_ve-_vQvvv71Ydjnvv70TYO-_ve-_ve-_ve-_vWTvv70877-9fO-_ve-_vShdM--_vVzvv70X77-977-977-9'

Vue.use(VueMeta)

Vue.use(PrismicVue, {
  endpoint: window.prismic.endpoint,
  linkResolver,
  apiOptions: { accessToken }
})

Vue.config.productionTip = false

Vue.prototype.$device = Devices

Vue.directive('click-outside', OutClickDirective)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
